<div class="deal-container deal-page">
  <button type="button" class="deal-back" *ngIf="!documentsOnly" (click)="goBack()">
    <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12 4l-6 6 6 6"/></svg>
    {{ t('ffDeal.back', 'Мои сделки') }}
  </button>

  <div *ngIf="loading" class="loading">{{ loadingText }}</div>
  <div *ngIf="error" class="error-message">{{ error }}</div>

  <ng-container *ngIf="!loading && !error && deal as d">
    <!-- Режим «только документы» (вкладка «Таможенная очистка» поставки): без шапки, оплаты, отчёта и хода сделки -->
    <ng-container *ngIf="!documentsOnly">
    <!-- Шапка: номер и статус, маршрут крупно, чат справа -->
    <header class="deal-head">
      <div class="deal-head__titles">
        <div class="deal-head__meta">
          <span class="deal-head__num">{{ titleText }} {{ d.id | docNo:'D':d.createdAt }}</span>
          <span class="rate-pill" *ngIf="d.cargoRequest.rateType">{{ rateLabel(d.cargoRequest.rateType) }}</span>
        </div>
        <h1>{{ d.cargoRequest.fromCity }} <span class="arrow" aria-hidden="true">→</span> {{ d.cargoRequest.toCity }}</h1>
        <p class="deal-head__sub">
          {{ getCountryName(d.cargoRequest.fromCountry) }} → {{ getCountryName(d.cargoRequest.toCountry) }}
        </p>
        <div class="deal-head__assign" *ngIf="(isCargoOwner || isFreightForwarder) && companyContext.company && (companyContext.hasPermission('ASSIGN_DEALS') || d.operatorName)">
          <app-assignee-select kind="operator" [entityId]="d.id" [currentId]="d.operatorId" [currentName]="d.operatorName"
                               [canEdit]="companyContext.hasPermission('ASSIGN_DEALS')"
                               (assigned)="onOperatorAssigned($event)"></app-assignee-select>
        </div>
      </div>

      <!-- Счётчик дней рядом с маршрутом: создана → передан на перевозку → доставлен -->
      <section class="days-track" *ngIf="dealTimeline as tl">
        <div class="days-track__step is-done">
          <span class="days-track__dot" aria-hidden="true"><svg viewBox="0 0 20 20"><path d="M4.5 10.5l3.5 3.5 7.5-8"/></svg></span>
          <strong>{{ t('ffDeal.stepCreated', 'Сделка создана') }}</strong>
          <small>{{ tl.created | date:'dd.MM.yyyy' }}</small>
        </div>

        <div class="days-track__gap" [class.is-running]="!tl.handover && !tl.delivered">
          <em class="days-track__label">{{ t('ffDeal.preparation', 'Подготовка') }}</em>
          <span>{{ daysLabel(tl.toHandover ?? 0) }}</span>
        </div>

        <div class="days-track__step" [class.is-done]="tl.handover || tl.delivered">
          <span class="days-track__dot" aria-hidden="true">
            <svg *ngIf="tl.handover || tl.delivered" viewBox="0 0 20 20"><path d="M4.5 10.5l3.5 3.5 7.5-8"/></svg>
          </span>
          <strong>{{ t('ffDeal.stepHandover', 'Груз передан') }}</strong>
          <small>{{ tl.handover ? (tl.handover | date:'dd.MM.yyyy') : t('ffDeal.waiting', 'ожидается') }}</small>
        </div>

        <div class="days-track__gap" [class.is-running]="tl.handover && !tl.delivered">
          <em class="days-track__label">{{ t('ffDeal.inTransit', 'Груз в пути') }}</em>
          <span *ngIf="tl.inTransit != null">{{ daysLabel(tl.inTransit) }}</span>
        </div>

        <div class="days-track__step" [class.is-done]="tl.delivered">
          <span class="days-track__dot" aria-hidden="true">
            <svg *ngIf="tl.delivered" viewBox="0 0 20 20"><path d="M4.5 10.5l3.5 3.5 7.5-8"/></svg>
          </span>
          <strong>{{ t('ffDeal.stepDelivered', 'Груз доставлен') }}</strong>
          <small>{{ tl.delivered ? (tl.delivered | date:'dd.MM.yyyy') : t('ffDeal.waiting', 'ожидается') }}</small>
        </div>

      </section>

      <!-- Статус перевозки — справа от счётчика -->
      <!-- Текущий этап перевозки — главное, что нужно видеть сразу -->
      <section class="stage-card">
        <div class="stage-card__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>
        </div>
        <div class="stage-card__text">
          <div class="stage-card__label">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>
            {{ statusBlockText }}
          </div>
          <!-- Статус крупно, под ним — комментарий (полный текст — в маленьком окне) -->
          <!-- Одной строкой: статус — комментарий [+] · время обновления -->
          <div class="stage-card__headline" *ngIf="lastStatusActivity as s">
            <strong class="stage-card__title">{{ stageTitle(s) }}</strong>
            <ng-container *ngIf="stageNote(s) as note">
              <span class="stage-card__dash" aria-hidden="true">—</span>
              <span class="stage-card__note-inline" [attr.title]="note" (click)="stageNoteOpen = true">{{ note }}</span>
              <button type="button" class="stage-card__plus" (click)="stageNoteOpen = true"
                      [attr.title]="t('ffRequest.more', 'Подробнее')" [attr.aria-label]="t('ffRequest.more', 'Подробнее')">+</button>
            </ng-container>
            <span class="stage-card__time" [attr.title]="t('ffDeal.updated', 'Обновлено') + ' ' + formatDate(s.createdAt)"><svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="7.5"/><path d="M10 6v4.2l2.6 1.6"/></svg>{{ s.createdAt | date:'dd.MM.yyyy HH:mm' }}</span>
          </div>
          <strong class="stage-card__title" *ngIf="!lastStatusActivity">{{ noStatusText }}</strong>

          <!-- «Изменить статус» и справа от него — напоминание экспедитору про 13:00 -->
          <div class="stage-card__actions" *ngIf="(isFreightForwarder || isCustomsBroker) && canWorkDeal">
            <button type="button" class="stage-card__change" (click)="openAddStatusModal()">
              <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M13.5 3.5l3 3L7 16H4v-3z"/></svg>
              {{ changeStatusText }}
            </button>
            <span class="stage-card__rule" *ngIf="isFreightForwarder && !dealTimeline.delivered" [class.is-due]="!stageUpdatedToday">
              <svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="7.5"/><path d="M10 6v4.2l2.6 1.6"/></svg>
              <span class="stage-card__rule-text">
                <b>{{ stageUpdatedToday ? t('ffDeal.ruleOk1', 'Сегодня статус обновлён.') : t('ffDeal.ruleDue1', 'Сегодня статус ещё не обновлён.') }}</b>
                <span>{{ t('ffDeal.rule2', 'Ежедневно до 13:00 (местное время)') }}</span>
              </span>
            </span>
          </div>
        </div>
      </section>
    </header>

    <!-- Чат по сделке — плавающая кнопка внизу экрана, окно открывается из неё -->
    <button #chatBtn *ngIf="canWorkDeal" type="button" class="pp-btn deal-chat-btn deal-chat-fab" [class.is-active]="chatOpen && !chatClosing"
            (click)="chatOpen ? closeChat() : openChat(chatBtn)">
      <svg class="deal-chat-btn__logo" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3a9 9 0 0 0-7.8 13.5L3 21l4.6-1.2A9 9 0 1 0 12 3z"/><circle cx="8.2" cy="12" r="1.1"/><circle cx="12" cy="12" r="1.1"/><circle cx="15.8" cy="12" r="1.1"/></svg>
      {{ isCargoOwner ? t('ffDeal.chatForwarder', 'Чат с экспедитором') : t('ffRequest.chat', 'Чат с клиентом') }}
      <span class="chat-unread" *ngIf="unreadCount > 0" [attr.title]="t('ffRequest.newMessages', 'Новых сообщений: {n}').replace('{n}', '' + unreadCount)">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </button>

    <!-- Клиент · параметры груза · ставка -->
    <div class="stage-row">
        <!-- Участник сделки -->
        <section class="pp-card deal-card party-card">
          <div class="deal-card__head">
            <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 21V8l9-5 9 5v13"/><path d="M9 21v-6h6v6"/></svg></span>{{ isCargoOwner ? freightForwarderText : t('ffDeal.client', 'Клиент') }}</h2>
            <button type="button" class="link-chip" (click)="viewRequisites()">{{ showRequisitesText }}</button>
          </div>
          <ng-container *ngIf="(isCargoOwner ? d.freightForwarder : d.cargoOwner) as p">
            <!-- Каждое значение с подписью, как в карточках «Груз» и «Ставка» -->
            <dl class="party__facts">
              <div>
                <dt>{{ t('ffDeal.company', 'Компания') }}</dt>
                <dd class="party__company">{{ p.companyName }}</dd>
              </div>
              <div *ngIf="p.phone">
                <dt>{{ t('ffDeal.phone', 'Телефон') }}</dt>
                <dd><a [href]="'tel:' + p.phone">{{ p.phone }}</a></dd>
              </div>
              <div *ngIf="p.email">
                <dt>{{ t('ffDeal.email', 'Эл. почта') }}</dt>
                <dd><a [href]="'mailto:' + p.email">{{ p.email }}</a></dd>
              </div>
            </dl>
          </ng-container>
        </section>

        <!-- Параметры груза — между клиентом и ставкой -->
        <section class="pp-card deal-card bid-mini cargo-card">
          <div class="deal-card__head">
            <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M21 8l-9-5-9 5v8l9 5 9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/></svg></span>{{ t('ffDeal.cargoTitle', 'Груз') }}</h2>
            <button type="button" class="link-chip" (click)="viewRequest()">{{ d.cargoRequest.id | docNo:'R':d.cargoRequest.createdAt }}
              <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M8 5l5 5-5 5"/></svg>
            </button>
          </div>
          <dl class="cargo-card__facts">
            <div>
              <dt>{{ t('ffRequest.totalWeight', 'Общий вес') }}</dt>
              <dd>{{ fmtWeight(totalWeight) }}</dd>
            </div>
            <div>
              <dt>{{ t('ffRequest.totalVolume', 'Общий объём') }}</dt>
              <dd>{{ fmtVolume(totalVolume) }}</dd>
            </div>
            <div>
              <dt>{{ t('ffRequest.totalPlaces', 'Всего мест') }}</dt>
              <dd>{{ placesCount }}</dd>
            </div>
            <div *ngIf="d.cargoRequest.price">
              <dt>{{ t('freightForwarder.requests.price', 'Стоимость груза') }}</dt>
              <dd>{{ fmtMoney(d.cargoRequest.price, d.cargoRequest.currency?.code) }}</dd>
            </div>
          </dl>
        </section>

        <!-- Ставка -->
        <section class="pp-card deal-card bid-mini" *ngIf="d.bid as b">
          <div class="deal-card__head">
            <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 12V4h8l10 10-8 8L3 12z"/><circle cx="7.5" cy="8.5" r="1.5"/></svg></span>{{ t('ffRequest.bidNo', 'Ставка') }}</h2>
            <button type="button" class="link-chip" (click)="viewBid()">{{ b.id | docNo:'B':b.createdAt }}
              <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M8 5l5 5-5 5"/></svg>
            </button>
          </div>
          <div class="deal-price">
            <small>{{ t('ffBid.price', 'Стоимость перевозки') }}</small>
            <strong>{{ fmtMoney(b.price, b.currencyCode) }}</strong>
          </div>
          <dl class="deal-facts deal-facts--stack">
            <div>
              <dt>{{ deliveryDaysText }}</dt>
              <dd>{{ b.deliveryDays }} {{ daysText }}</dd>
            </div>
          </dl>
        </section>
    </div>

    <!-- Оплата за перевозку: счета в ₸ по курсу на день счёта, оплаты в ₸, задолженность -->
    <section class="pp-card pay-card" *ngIf="d.bid && pay as p">
      <div class="pay-card__head">
        <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="3" y="6" width="18" height="13" rx="2"/><path d="M3 10h18M7 15h4"/></svg></span>{{ t('ffPay.title', 'Оплата за перевозку') }}</h2>
        <span class="pay-badge" [ngClass]="'pay-badge--' + payState">
          {{ payState === 'paid' ? t('ffPay.paid', 'Оплачено полностью')
            : payState === 'over' ? t('ffPay.overState', 'Оплачено с переплатой')
            : payState === 'partial' ? t('ffPay.partial', 'Оплачено частично')
            : payState === 'none' ? t('ffPay.notPaid', 'Не оплачено')
            : t('ffPay.noInvoice', 'Счёт не выставлен') }}
        </span>
        <div class="pay-card__actions" *ngIf="isCargoOwner && p.invoices.length">
          <button type="button" class="pay-card__add" (click)="openPaymentModal()">+ {{ t('ffPay.sendOrder', 'Отправить платёжку') }}</button>
        </div>
        <div class="pay-card__actions" *ngIf="isFreightForwarder && canWorkDeal">
          <button type="button" class="pay-card__add" (click)="openInvoiceModal()">+ {{ t('ffPay.invoiceAdd', 'Выставить счёт') }}</button>
          <button *ngIf="p.hasDebt" type="button" class="pay-card__add pay-card__add--ghost" (click)="openPaymentModal()">+ {{ t('ffPay.add', 'Подтвердить оплату') }}</button>
        </div>
      </div>

      <div class="pay-sum pay-sum--4">
        <div><small>{{ t('ffPay.byBid', 'По ставке') }}</small><b>{{ fmtMoney(payTotal, payCurrency) }}</b></div>
        <div><small>{{ t('ffPay.invoiced', 'Выставлено') }}</small><b>{{ fmtTotals('invoiced') }}</b></div>
        <div><small>{{ t('ffPay.paidSum', 'Оплачено') }}</small><b class="is-green">{{ fmtTotals('paid') }}</b><span class="pay-sum__pending" *ngIf="p.hasPending">+ {{ fmtTotals('pending') }} {{ t('ffPay.pendingShort', 'ждёт подтверждения') }}</span></div>
        <!-- Нет долга, но оплачено больше выставленного — вместо задолженности переплата -->
        <div *ngIf="p.hasDebt || !p.hasOverpay; else overCell">
          <small>{{ t('ffCp.debt', 'Задолженность') }}</small><b [class.is-due]="p.hasDebt">{{ fmtTotals('debt') }}</b>
          <span class="pay-sum__over" *ngIf="p.hasOverpay">{{ t('ffPay.overShort', 'переплата') }} {{ fmtTotals('overpaid') }}</span>
        </div>
        <ng-template #overCell>
          <div>
            <small>{{ t('ffPay.overpaid', 'Переплата') }}</small><b class="is-over">{{ fmtTotals('overpaid') }}</b>
            <span class="pay-sum__over-hint">{{ t('ffPay.overHint', 'зачтётся в следующий счёт') }}</span>
          </div>
        </ng-template>
        <div class="pay-bar" [attr.title]="payPercent + '%'"><span [style.width.%]="payPercent"></span></div>
      </div>

      <div class="pay-lists" *ngIf="p.invoices.length || p.payments.length; else noMoney">
        <div>
          <h3>{{ t('ffPay.invoices', 'Счета') }}</h3>
          <ul class="pay-list" *ngIf="p.invoices.length; else noInvoices">
            <li *ngFor="let i of p.invoices" [class.is-revoked]="i.revoked">
              <span class="pay-list__amount pay-list__amount--ink">{{ fmtCur(i.amount, i.currency) }}</span>
              <span class="pay-list__date" [attr.title]="i.edited ? t('ffPay.edited', 'Изменён') : null">№ {{ i.number }} · {{ i.date }}</span>
              <span class="pay-state pay-state--off" *ngIf="i.revoked" [attr.title]="i.revokeReason || null">{{ t('ffPay.revoked', 'Отозван') }}</span>
              <ng-container *ngIf="isFreightForwarder && canWorkDeal && !i.revoked">
                <button *ngIf="canEditInvoice(i)" type="button" class="pay-dl" (click)="openInvoiceEdit(i)"
                        [attr.title]="t('ffPay.invoiceEdit', 'Изменить счёт')" [attr.aria-label]="t('ffPay.invoiceEdit', 'Изменить счёт')">
                  <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 16h3l8.5-8.5-3-3L4 13v3zM11 6l3 3"/></svg>
                </button>
                <button type="button" class="pay-dl pay-dl--danger" (click)="openInvoiceRevoke(i)"
                        [attr.title]="t('ffPay.invoiceRevoke', 'Отозвать счёт')" [attr.aria-label]="t('ffPay.invoiceRevoke', 'Отозвать счёт')">
                  <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7 5L3 9l4 4M3 9h9a5 5 0 010 10h-1"/></svg>
                </button>
              </ng-container>
              <button *ngIf="invoiceFileOf(i) as f" type="button" class="pay-dl" (click)="openPreview(f, $event)"
                      [attr.title]="t('ffDocs.view', 'Посмотреть') + ': ' + f.fileName" [attr.aria-label]="t('ffDocs.view', 'Посмотреть')">
                <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M1.5 10S4.5 4 10 4s8.5 6 8.5 6-3 6-8.5 6-8.5-6-8.5-6z"/><circle cx="10" cy="10" r="2.5"/></svg>
              </button>
            </li>
          </ul>
          <ng-template #noInvoices><p class="pay-empty">{{ t('ffPay.noInvoices', 'Счетов пока нет') }}</p></ng-template>
        </div>
        <div>
          <h3>{{ t('ffPay.paymentsTitle', 'Оплаты') }}</h3>
          <ul class="pay-list" *ngIf="p.payments.length; else noPays">
            <li *ngFor="let x of p.payments" [class.is-revoked]="x.revoked">
              <span class="pay-list__amount">{{ fmtCur(x.amount, x.currency) }}</span>
              <span class="pay-list__date" [attr.title]="x.edited ? t('ffPay.editedF', 'Изменена') : null">{{ x.date }}</span>
              <span class="pay-list__note" *ngIf="x.note" [attr.title]="x.note">{{ x.note }}</span>
              <span class="pay-state pay-state--off" *ngIf="x.revoked" [attr.title]="x.revokeReason || null">{{ t('ffPay.revokedF', 'Отозвана') }}</span>
              <span class="pay-state" *ngIf="x.pending && !x.revoked">{{ t('ffPay.pending', 'Ждёт подтверждения') }}</span>
              <span class="pay-state pay-state--ok" *ngIf="x.fromOwner && !x.pending && !x.revoked">{{ t('ffPay.confirmed', 'Подтверждена') }}</span>
              <button *ngIf="canEditPayment(x)" type="button" class="pay-dl" (click)="openPaymentEdit(x)"
                      [attr.title]="t('ffPay.paymentEdit', 'Изменить оплату')" [attr.aria-label]="t('ffPay.paymentEdit', 'Изменить оплату')">
                <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 16h3l8.5-8.5-3-3L4 13v3zM11 6l3 3"/></svg>
              </button>
              <button *ngIf="canRevokePayment(x)" type="button" class="pay-dl pay-dl--danger" (click)="openPaymentRevoke(x)"
                      [attr.title]="revokeNeedsConsent(x) ? t('ffPay.paymentRevokeAsk', 'Запросить отзыв оплаты') : t('ffPay.paymentRevoke', 'Отозвать оплату')"
                      [attr.aria-label]="t('ffPay.paymentRevoke', 'Отозвать оплату')">
                <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7 5L3 9l4 4M3 9h9a5 5 0 010 10h-1"/></svg>
              </button>
              <button *ngIf="x.pending && !x.revoked && isFreightForwarder" type="button" class="pay-confirm"
                      [disabled]="confirmingPaymentId === x.activityId" (click)="confirmPayment(x)">
                {{ confirmingPaymentId === x.activityId ? t('ffPay.saving', 'Сохранение...') : t('ffPay.confirm', 'Подтвердить') }}
              </button>
              <button *ngIf="paymentFileOf(x) as f" type="button" class="pay-dl" (click)="openPreview(f, $event)"
                      [attr.title]="t('ffDocs.view', 'Посмотреть') + ': ' + f.fileName" [attr.aria-label]="t('ffDocs.view', 'Посмотреть')">
                <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M1.5 10S4.5 4 10 4s8.5 6 8.5 6-3 6-8.5 6-8.5-6-8.5-6z"/><circle cx="10" cy="10" r="2.5"/></svg>
              </button>
              <!-- Запрос клиента на отзыв подтверждённой оплаты -->
              <div class="pay-req" *ngIf="!x.revoked && x.revokeRequest as rq">
                <ng-container *ngIf="rq.state === 'pending'; else reqDeclined">
                  <span class="pay-req__text">
                    {{ isFreightForwarder ? t('ffPay.reqForFf', 'Клиент просит отозвать оплату') : t('ffPay.reqSent', 'Запрос на отзыв отправлен экспедитору') }}<ng-container *ngIf="rq.reason">: «{{ rq.reason }}»</ng-container>
                  </span>
                  <ng-container *ngIf="isFreightForwarder && canWorkDeal">
                    <button type="button" class="pay-confirm" [disabled]="confirmingPaymentId === x.activityId" (click)="answerRevokeRequest(x, true)">
                      {{ t('ffPay.reqApprove', 'Согласовать') }}
                    </button>
                    <button type="button" class="pay-req__decline" [disabled]="confirmingPaymentId === x.activityId" (click)="answerRevokeRequest(x, false)">
                      {{ t('ffPay.reqDecline', 'Отклонить') }}
                    </button>
                  </ng-container>
                </ng-container>
                <ng-template #reqDeclined>
                  <span class="pay-req__text">{{ t('ffPay.reqDeclined', 'Экспедитор отклонил отзыв оплаты') }}</span>
                </ng-template>
              </div>
            </li>
          </ul>
          <ng-template #noPays><p class="pay-empty">{{ t('ffPay.empty', 'Оплат пока нет.') }}</p></ng-template>
        </div>
      </div>
      <ng-template #noMoney>
        <p class="pay-empty">
          {{ isFreightForwarder
            ? t('ffPay.startFf', 'Выставьте клиенту счёт в тенге по курсу на день счёта — затем отмечайте оплаты.')
            : t('ffPay.start', 'Экспедитор ещё не выставил счёт.') }}
        </p>
      </ng-template>
    </section>

    </ng-container>

    <!-- Документы и отчёт — в одну строку, одной высоты; ниже — ход сделки на всю ширину -->
    <div class="docs-row" [class.docs-row--single]="documentsOnly">
    <!-- Документы -->
    <section class="pp-card deal-card">
      <div class="deal-card__head">
        <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M7 3h7l5 5v13H7z"/><path d="M14 3v5h5M10 13h6M10 17h6"/></svg></span>{{ documentsText }}</h2>
        <span class="count-pill">{{ docsReadyCount }} / {{ documentTypes.length }}</span>
      </div>
      <ul class="docs">
        <li *ngFor="let docType of documentTypes">
          <button type="button" class="doc" [class.is-ready]="documentCount(docType) > 0" (click)="openDocumentUploadModal(docType)">
            <span class="doc__mark" aria-hidden="true">
              <svg *ngIf="documentCount(docType) > 0" viewBox="0 0 20 20"><path d="M6 2.5h5.5L15 6v11.5H6z"/><path d="M11.5 2.5V6H15"/></svg>
              <svg *ngIf="documentCount(docType) === 0" viewBox="0 0 20 20"><path d="M10 4v12M4 10h12"/></svg>
            </span>
            <span class="doc__text">
              <span class="doc__name">{{ getTypeName(docType) }}</span>
              <small class="doc__count">{{ documentCount(docType) > 0 ? filesCountText(documentCount(docType)) + ' · ' + t('ffDocs.open', 'открыть') : t('ffDocs.upload', 'загрузить') }}</small>
            </span>
          </button>
        </li>
      </ul>
    </section>

    <!-- Отчёт по сделке -->
    <section *ngIf="(isCargoOwner || isFreightForwarder || isCustomsBroker) && !documentsOnly" class="pp-card deal-card">
      <div class="deal-card__head">
        <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/></svg></span>{{ reportBlockTitleText }}</h2>
      </div>
      <p class="muted">{{ openReportSeparatePageText }}</p>
      <button type="button" class="pp-btn pp-btn--ghost deal-report-btn" (click)="openReport()" [disabled]="loading">
        {{ openReportText }}
      </button>
    </section>
    </div>

    <ng-container *ngIf="!documentsOnly">
    <!-- Ход сделки — сворачиваемый список событий, новые сверху -->
    <section class="pp-card deal-card acts">
      <button type="button" class="acts__toggle" (click)="activitiesOpen = !activitiesOpen" [attr.aria-expanded]="activitiesOpen">
        <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg></span>{{ activitiesText }}</h2>
        <span class="count-pill">{{ d.activities?.length || 0 }}</span>
        <span class="acts__latest" *ngIf="!activitiesOpen && sortedActivities[0] as last">
          {{ getActivityText(last) }} · {{ last.createdAt | date:'dd.MM.yyyy' }}
        </span>
        <span class="acts__chevron" [class.is-open]="activitiesOpen" aria-hidden="true">
          {{ activitiesOpen ? t('ffRequest.collapse', 'Свернуть') : t('ffDeal.show', 'Показать') }}
          <svg viewBox="0 0 20 20"><path d="M5 8l5 5 5-5"/></svg>
        </span>
      </button>

      <div class="acts__body" *ngIf="activitiesOpen">
        <div *ngIf="!d.activities || d.activities.length === 0" class="no-activities">{{ noActivitiesText }}</div>
        <ol class="acts__list" *ngIf="sortedActivities.length > 0">
          <li *ngFor="let activity of sortedActivities" class="act" [ngClass]="'act--' + (getActivityCategory(activity) || 'default')">
            <button type="button" class="act__row" (click)="openActivityModal(activity)">
              <span class="act__dot" aria-hidden="true"></span>
              <span class="act__main">
                <span class="act__title">{{ getActivityText(activity) }}</span>
                <span class="act__meta">
                  <span *ngIf="activity.request && !activity.completed" class="act__state">{{ requestPendingText }}</span>
                  <span *ngIf="activity.request && activity.completed" class="act__state act__state--done">{{ requestCompletedText }}</span>
                </span>
              </span>
              <span class="act__date">{{ formatDate(activity.createdAt) }}</span>
            </button>
          </li>
        </ol>
      </div>
    </section>

    <!-- Чат по сделке — окно-мессенджер, как на странице запроса -->
    <div class="chat-backdrop" *ngIf="chatOpen" [class.is-closing]="chatClosing" (click)="closeChat()"></div>
    <aside class="chat-panel" *ngIf="chatOpen && chatBox as box" [class.is-closing]="chatClosing"
           [style.top.px]="box.top" [style.left.px]="box.left" [style.width.px]="box.width" [style.height.px]="box.height"
           [style.transform-origin]="box.origin"
           role="dialog" aria-modal="true" [attr.aria-label]="t('ffDeal.chat', 'Чат по сделке')">
      <header class="chat-panel__head">
        <span class="chat-panel__avatar" aria-hidden="true">
          <svg viewBox="0 0 24 24"><circle cx="12" cy="8.5" r="3.6"/><path d="M5 19.5c1.2-3.4 3.9-5 7-5s5.8 1.6 7 5"/></svg>
        </span>
        <div class="chat-panel__titles">
          <h2>{{ (isCargoOwner ? d.freightForwarder : d.cargoOwner).companyName }}</h2>
          <p>{{ titleText }} {{ d.id | docNo:'D':d.createdAt }} · {{ d.cargoRequest.fromCity }} → {{ d.cargoRequest.toCity }}</p>
        </div>
        <button type="button" class="chat-panel__close" (click)="closeChat()" [attr.aria-label]="t('common.close', 'Закрыть')">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
        </button>
      </header>
      <div class="chat-panel__body">
        <app-chat contextType="DEAL" [contextId]="d.id"></app-chat>
      </div>
    </aside>
    </ng-container>
  </ng-container>

  <!-- Выставить счёт: сразу в тенге, по курсу банка экспедитора -->
  <!-- Отзыв счёта или оплаты (подтверждённую оплату клиент отзывает только с согласия экспедитора) -->
  <div class="modal-overlay" *ngIf="revokingInvoice || revokingPayment" (click)="closeRevoke()">
    <div class="modal-content modal-activity" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{ revokingInvoice ? t('ffPay.invoiceRevoke', 'Отозвать счёт')
             : revokeNeedsConsent(revokingPayment!) ? t('ffPay.paymentRevokeAsk', 'Запросить отзыв оплаты') : t('ffPay.paymentRevoke', 'Отозвать оплату') }}</h2>
        <button class="modal-close" (click)="closeRevoke()" [attr.aria-label]="t('common.close', 'Закрыть')">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>
      <div class="modal-body">
        <p class="pay-modal__hint" *ngIf="revokingInvoice as ri">{{ t('ffPay.invoiceShort', 'Счёт') }} № {{ ri.number }} · {{ ri.date }} · <b>{{ fmtCur(ri.amount, ri.currency) }}</b></p>
        <p class="pay-modal__hint" *ngIf="revokingPayment as rp">{{ t('ffPay.paymentShort', 'Оплата') }} · {{ rp.date }} · <b>{{ fmtCur(rp.amount, rp.currency) }}</b></p>
        <p class="pay-modal__small">
          {{ revokingInvoice
            ? t('ffPay.revokeHint', 'Счёт останется в списке зачёркнутым и не будет учитываться в сумме и задолженности. Клиент увидит, что счёт отозван.')
            : revokeNeedsConsent(revokingPayment!)
              ? t('ffPay.revokeAskHint', 'Экспедитор уже подтвердил эту оплату — отозвать её можно только с его согласия. Экспедитор получит запрос.')
              : t('ffPay.revokePayHint', 'Оплата останется в списке зачёркнутой и не будет учитываться в «Оплачено».') }}
        </p>
        <div class="form-group">
          <label>{{ t('ffPay.revokeReason', 'Причина (необязательно)') }}</label>
          <input type="text" class="form-control" [(ngModel)]="revokeReason" [ngModelOptions]="{ standalone: true }"
                 [placeholder]="t('ffPay.revokePh', 'Например: ошибка в сумме')" />
        </div>
        <div *ngIf="paymentError" class="error-message">{{ paymentError }}</div>
        <div class="form-actions">
          <button type="button" class="btn-cancel" (click)="closeRevoke()">{{ cancelText }}</button>
          <button type="button" class="btn-submit btn-submit--danger" [disabled]="paymentSaving" (click)="saveRevoke()">
            {{ paymentSaving ? t('ffPay.saving', 'Сохранение...')
              : revokingPayment && revokeNeedsConsent(revokingPayment) ? t('ffPay.sendRequest', 'Отправить запрос')
              : t('ffPay.revokeBtn', 'Отозвать') }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showInvoiceModal" (click)="closeInvoiceModal()">
    <div class="modal-content modal-activity" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{ editingInvoice ? t('ffPay.invoiceEdit', 'Изменить счёт') : t('ffPay.invoiceAdd', 'Выставить счёт') }}</h2>
        <button class="modal-close" (click)="closeInvoiceModal()" [attr.aria-label]="t('common.close', 'Закрыть')">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>
      <div class="modal-body">
        <p class="pay-modal__hint">{{ t('ffPay.byBid', 'По ставке') }}: <b>{{ fmtMoney(payTotal, payCurrency) }}</b></p>
        <p class="pay-modal__small" *ngIf="editingInvoice">{{ t('ffPay.editWindow', 'Изменить можно в течение 10 минут после отправки.') }}</p>
        <div class="pay-modal__row">
          <div class="form-group">
            <label>{{ t('ffPay.invoiceNumber', 'Номер счёта') }}</label>
            <input type="text" class="form-control" [(ngModel)]="invoiceNumber" [ngModelOptions]="{ standalone: true }" />
          </div>
          <div class="form-group">
            <label>{{ t('ffPay.invoiceDate', 'Дата счёта') }}</label>
            <input type="date" class="form-control" [(ngModel)]="invoiceDate" [ngModelOptions]="{ standalone: true }" />
          </div>
        </div>
        <div class="pay-modal__row pay-modal__row--cur">
          <div class="form-group">
            <label>{{ t('ffPay.invoiceAmount', 'Сумма счёта') }}</label>
            <input type="number" class="form-control" min="0.01" step="0.01" [(ngModel)]="invoiceAmount" [ngModelOptions]="{ standalone: true }" />
          </div>
          <div class="form-group">
            <label>{{ t('ffPay.currency', 'Валюта') }}</label>
            <select class="form-control" [(ngModel)]="invoiceCurrency" [ngModelOptions]="{ standalone: true }">
              <option *ngFor="let c of invoiceCurrencies" [value]="c">{{ c === 'KZT' ? 'KZT (₸)' : c }}</option>
            </select>
          </div>
        </div>
        <p class="pay-modal__small">{{ t('ffPay.curHint', 'Валюта — как в вашем счёте клиенту.') }}</p>
        <div class="form-group">
          <label>{{ t('ffPay.invoiceFile', 'Файл счёта (необязательно)') }} <small class="pay-file__hint">{{ t('ffPay.invoiceFileHint', '— сохранится в «Документы → Другие документы»') }}</small></label>
          <label class="pay-file">
            <input type="file" (change)="onInvoiceFile($event)" hidden />
            <span>{{ invoiceFile?.name || t('ffPay.chooseFile', 'Выбрать файл') }}</span>
          </label>
        </div>
        <div *ngIf="paymentError" class="error-message">{{ paymentError }}</div>
        <div class="form-actions">
          <button type="button" class="btn-cancel" (click)="closeInvoiceModal()">{{ cancelText }}</button>
          <button type="button" class="btn-submit" [disabled]="paymentSaving" (click)="saveInvoice()">
            {{ paymentSaving ? t('ffPay.saving', 'Сохранение...') : editingInvoice ? t('ffPay.saveEdit', 'Сохранить') : t('ffPay.invoiceSave', 'Выставить счёт') }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Подтвердить оплату / отправить платёжку — в валюте счёта -->
  <div class="modal-overlay" *ngIf="showPaymentModal" (click)="closePaymentModal()">
    <div class="modal-content modal-activity" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{ editingPayment ? t('ffPay.paymentEdit', 'Изменить оплату') : isCargoOwner ? t('ffPay.sendOrder', 'Отправить платёжку') : t('ffPay.add', 'Подтвердить оплату') }}</h2>
        <button class="modal-close" (click)="closePaymentModal()" [attr.aria-label]="t('common.close', 'Закрыть')">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>
      <div class="modal-body">
        <p class="pay-modal__hint" *ngIf="!editingPayment">{{ t('ffCp.debt', 'Задолженность') }}: <b>{{ fmtTotals('debt') }}</b></p>
        <p class="pay-modal__small" *ngIf="editingPayment">{{ t('ffPay.editWindow', 'Изменить можно в течение 10 минут после отправки.') }}</p>
        <div class="pay-modal__row pay-modal__row--cur">
          <div class="form-group">
            <label>{{ t('ffPay.amount', 'Сумма') }}</label>
            <input type="number" class="form-control" min="0.01" step="0.01" [(ngModel)]="paymentAmount" [ngModelOptions]="{ standalone: true }" />
          </div>
          <div class="form-group">
            <label>{{ t('ffPay.currency', 'Валюта') }}</label>
            <select class="form-control" [(ngModel)]="paymentCurrency" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onPaymentCurrency()">
              <option *ngFor="let c of paymentCurrencies" [value]="c">{{ c === 'KZT' ? 'KZT (₸)' : c }}</option>
            </select>
          </div>
        </div>
        <!-- Реквизиты платёжного поручения — по желанию -->
        <div class="pay-modal__row">
          <div class="form-group">
            <label>{{ t('ffPay.orderNo', 'Номер платёжки (необязательно)') }}</label>
            <input type="text" class="form-control" [(ngModel)]="paymentOrderNo" [ngModelOptions]="{ standalone: true }" />
          </div>
          <div class="form-group">
            <label>{{ t('ffPay.orderDate', 'Дата платёжки (необязательно)') }}</label>
            <input type="date" class="form-control" [(ngModel)]="paymentOrderDate" [ngModelOptions]="{ standalone: true }" />
          </div>
        </div>
        <div class="form-group">
          <label>{{ t('ffPay.note', 'Комментарий (необязательно)') }}</label>
          <input type="text" class="form-control" [(ngModel)]="paymentNote" [ngModelOptions]="{ standalone: true }" [placeholder]="t('ffPay.notePh', 'Например: предоплата 50%')" />
        </div>
        <div class="form-group">
          <label>{{ editingPayment ? t('ffPay.fileReplace', 'Новый файл платёжки (необязательно)') : isCargoOwner ? t('ffPay.fileOwner', 'Платёжное поручение') : t('ffPay.file', 'Платёжное поручение (необязательно)') }}</label>
          <label class="pay-file">
            <input type="file" (change)="onPaymentFile($event)" hidden />
            <span>{{ paymentFile?.name || t('ffPay.chooseFile', 'Выбрать файл') }}</span>
          </label>
        </div>
        <p class="pay-modal__warn" *ngIf="paymentExcess > 0">
          {{ t('ffPay.overWarn1', 'Сумма больше задолженности на') }} {{ fmtCur(paymentExcess, paymentCurrency) }}.
          {{ t('ffPay.overWarn2', 'Будет переплата — она зачтётся в следующий счёт.') }}
        </p>
        <div *ngIf="paymentError" class="error-message">{{ paymentError }}</div>
        <div class="form-actions">
          <button type="button" class="btn-cancel" (click)="closePaymentModal()">{{ cancelText }}</button>
          <button type="button" class="btn-submit" [disabled]="paymentSaving" (click)="savePayment()">
            {{ paymentSaving ? t('ffPay.saving', 'Сохранение...') : editingPayment ? t('ffPay.saveEdit', 'Сохранить') : (isCargoOwner ? t('ffPay.sendToFf', 'Отправить экспедитору') : t('ffPay.save', 'Подтвердить оплату')) }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Полный комментарий к текущему этапу -->
  <div class="modal-overlay" *ngIf="stageNoteOpen && lastStatusActivity" (click)="stageNoteOpen = false">
    <div class="modal-content modal-activity modal-note" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{ stageTitle(lastStatusActivity!) }}</h2>
        <button class="modal-close" (click)="stageNoteOpen = false" [attr.aria-label]="t('common.close', 'Закрыть')">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>
      <div class="modal-body">
        <p class="note-full">{{ stageNote(lastStatusActivity!) }}</p>
        <small class="note-date">{{ t('ffDeal.updated', 'Обновлено') }} {{ formatDate(lastStatusActivity!.createdAt) }}</small>
      </div>
    </div>
  </div>

  <!-- Модальное окно для просмотра запроса -->
  <div class="modal-overlay" *ngIf="showRequestModal" (click)="closeRequestModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{ cargoRequestText }} {{ deal?.cargoRequest?.id | docNo:'R':deal?.cargoRequest?.createdAt }}</h2>
        <button class="modal-close" (click)="closeRequestModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="modal-body req-view" *ngIf="deal?.cargoRequest as r">
        <!-- Перевозка — как на странице запроса -->
        <section class="req-view__card">
          <h3>{{ t('ffRequest.shipping', 'Перевозка') }}</h3>
          <dl class="req-view__facts">
            <div>
              <dt>{{ t('ffRequest.transport', 'Тип перевозки') }}</dt>
              <dd>{{ rateLabel(r.rateType) }}</dd>
            </div>
            <div *ngIf="r.createdAt">
              <dt>{{ t('ffRequest.published', 'Опубликован') }}</dt>
              <dd>{{ r.createdAt | date:'dd.MM.yyyy' }}</dd>
            </div>
            <div *ngIf="r.loadingDate">
              <dt>{{ t('freightForwarder.requests.loadingDate', 'Дата погрузки') }}</dt>
              <dd>{{ r.loadingDate | date:'dd.MM.yyyy' }}</dd>
            </div>
            <div>
              <dt>{{ t('ffRequest.totalWeight', 'Общий вес') }}</dt>
              <dd>{{ fmtWeight(totalWeight) }}</dd>
            </div>
            <div>
              <dt>{{ t('ffRequest.totalVolume', 'Общий объём') }}</dt>
              <dd>{{ fmtVolume(totalVolume) }}</dd>
            </div>
            <div *ngIf="r.price">
              <dt>{{ t('freightForwarder.requests.price', 'Стоимость груза') }}</dt>
              <dd>{{ fmtMoney(r.price, r.currency?.code) }}</dd>
            </div>
          </dl>
          <ul class="req-view__traits">
            <li *ngFor="let f of cargoTraits" [class.is-warn]="f.warn">{{ f.label }}</li>
          </ul>
        </section>

        <!-- Грузовые места -->
        <section class="req-view__card">
          <div class="req-view__head">
            <h3>{{ t('ffRequest.itemsTitle', 'Грузовые места') }}</h3>
            <span class="count-pill">{{ t('ffRequest.itemsTotal', 'Всего: {n}').replace('{n}', '' + placesCount) }}</span>
          </div>
          <ul class="req-view__items">
            <li *ngFor="let p of r.products; let i = index" class="req-view__item">
              <div class="req-view__item-head">
                <span class="req-view__num">{{ i + 1 }}</span>
                <strong>{{ p.name || productTypeName(p) || t('ffRequest.item', 'Груз') }}</strong>
                <span class="req-view__icons" *ngIf="p.isDangerous || p.isOversized || p.isNonStackable">
                  <span class="req-view__icon is-warn" *ngIf="p.isDangerous" [attr.title]="t('ffSearch.dangerous', 'Опасный груз')">
                    <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 3.5l7 12.5H3z M10 8.5v3.5 M10 14.2v.1"/></svg>
                  </span>
                  <span class="req-view__icon is-warn" *ngIf="p.isOversized" [attr.title]="t('ffSearch.oversized', 'Крупногабаритный груз')">
                    <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M3 7V3h4 M13 3h4v4 M17 13v4h-4 M7 17H3v-4 M3 3l5 5 M17 3l-5 5 M17 17l-5-5 M3 17l5-5"/></svg>
                  </span>
                  <span class="req-view__icon" *ngIf="p.isNonStackable" [attr.title]="t('ffSearch.nonStackable', 'Не штабелировать')">
                    <svg viewBox="0 0 20 20" aria-hidden="true"><rect x="5" y="11" width="10" height="6" rx="1"/><rect x="5" y="3" width="10" height="6" rx="1"/><path d="M3 2l14 16"/></svg>
                  </span>
                </span>
              </div>
              <dl class="req-view__grid">
                <div>
                  <dt>{{ t('ffRequest.itemPlaces', 'Количество мест') }}</dt>
                  <dd>{{ productQty(p) }}</dd>
                </div>
                <div>
                  <dt>{{ t('ffSearch.weight', 'Вес') }}</dt>
                  <dd>{{ fmtWeight(p.totalWeightKg) }}</dd>
                </div>
                <div>
                  <dt>{{ t('ffSearch.volume', 'Объём') }}</dt>
                  <dd>{{ fmtVolume(productVolumeOf(p)) }}</dd>
                </div>
                <div>
                  <dt>{{ t('ffRequest.itemSize', 'Размер места, мм') }}</dt>
                  <dd>{{ p.lengthMm && p.widthMm && p.heightMm ? (p.lengthMm + ' × ' + p.widthMm + ' × ' + p.heightMm) : '—' }}</dd>
                </div>
                <div>
                  <dt>{{ t('ffRequest.tnved', 'Код ТНВЭД') }}</dt>
                  <dd>{{ p.tnvedCode || '—' }}</dd>
                </div>
              </dl>
            </li>
          </ul>
        </section>
      </div>
    </div>
  </div>

  <!-- Модальное окно для изменения статуса -->
  <div class="modal-overlay" *ngIf="showAddStatusModal" (click)="closeAddStatusModal()">
    <div class="modal-content modal-activity" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{ changeStatusText }}</h2>
        <button class="modal-close" (click)="closeAddStatusModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="statusForm" (ngSubmit)="submitStatusActivity()">
          <div class="form-group">
            <label>{{ t('ffDeal.stageLabel', 'Этап перевозки') }}</label>
            <select formControlName="activityTypeCode" class="form-control">
              <option value="">{{ t('ffDeal.selectStage', 'Выберите этап') }}</option>
              <optgroup [label]="t('ffDeal.flowGroup', 'Ход перевозки')">
                <option *ngFor="let type of statusActivityTypes" [value]="type.code">{{ getTypeName(type) }}</option>
              </optgroup>
              <optgroup *ngIf="statusIssueTypes.length" [label]="t('ffDeal.issuesGroup', 'Отклонения')">
                <option *ngFor="let type of statusIssueTypes" [value]="type.code">{{ getTypeName(type) }}</option>
              </optgroup>
            </select>
          </div>
          <div class="form-group">
            <label>{{ t('ffDeal.stageComment', 'Комментарий (необязательно)') }}</label>
            <textarea formControlName="actorMessage" class="form-control" rows="2" 
                      [placeholder]="cityPlaceholderExampleText"></textarea>
          </div>
          <div *ngIf="statusError" class="error-message">
            {{ statusError }}
          </div>
          <div class="form-actions">
            <button type="button" class="btn-cancel" (click)="closeAddStatusModal()">
              {{ cancelText }}
            </button>
            <button type="submit" class="btn-submit" [disabled]="statusForm.invalid || creatingStatus">
              {{ creatingStatus ? creatingText : t('ffDeal.saveStage', 'Сохранить этап') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Модальное окно документа: список файлов или форма загрузки -->
  <!-- Просмотр файла без скачивания: PDF и картинки — прямо здесь, остальное — предложение скачать -->
  <div class="modal-overlay preview-overlay" *ngIf="preview as pv" (click)="closePreview()">
    <div class="modal-content preview-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="preview-modal__title" [attr.title]="pv.file.fileName">{{ pv.file.fileName }}</h2>
        <button type="button" class="pay-dl preview-modal__dl" (click)="onDownloadFile(pv.file, $event)" [attr.title]="t('ffPay.download', 'Скачать')">
          <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 3v10M6 9l4 4 4-4M4 16h12"/></svg>
          <span>{{ t('ffPay.download', 'Скачать') }}</span>
        </button>
        <button class="modal-close" (click)="closePreview()" [attr.aria-label]="t('common.close', 'Закрыть')">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>
      <div class="preview-modal__body">
        <p class="preview-modal__msg" *ngIf="pv.loading">{{ t('ffDocs.loading', 'Открываем файл…') }}</p>
        <p class="preview-modal__msg" *ngIf="pv.error">{{ t('ffDocs.previewError', 'Не удалось открыть файл. Попробуйте скачать его.') }}</p>
        <p class="preview-modal__msg" *ngIf="pv.kind === 'other'">{{ t('ffDocs.noPreview', 'Этот формат нельзя посмотреть в браузере — скачайте файл.') }}</p>
        <iframe *ngIf="pv.url && pv.kind !== 'image'" [src]="pv.url" [title]="pv.file.fileName"></iframe>
        <img *ngIf="pv.url && pv.kind === 'image'" [src]="pv.url" [alt]="pv.file.fileName" />
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showDocumentUploadModal" (click)="closeDocumentUploadModal()">
    <div class="modal-content modal-activity" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{ selectedDocumentType ? getTypeName(selectedDocumentType) : '' }}</h2>
        <button class="modal-close" (click)="closeDocumentUploadModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="modal-body" *ngIf="selectedDocumentType">
        <!-- Список загруженных документов -->
        <div *ngIf="!documentModalShowingUploadForm" class="document-list-view">
          <div class="section-header">
            <h4>{{ filesLabel }}</h4>
            <button class="link-button" (click)="showDocumentUploadForm()">{{ uploadText }}</button>
          </div>
          <div *ngIf="isLoadingDocumentFiles" class="loading-files">{{ loadingText }}</div>
          <div *ngIf="!isLoadingDocumentFiles && getDocumentFilesForType(selectedDocumentType).length === 0" class="no-files">
            {{ noFilesText }}
          </div>
          <div *ngIf="!isLoadingDocumentFiles && getDocumentFilesForType(selectedDocumentType).length > 0" class="uploaded-files">
            <div *ngFor="let file of getDocumentFilesForType(selectedDocumentType)" class="file-item uploaded">
              <a href="#" (click)="openPreview(file, $event)" class="file-name" [attr.title]="t('ffDocs.view', 'Посмотреть')">{{ file.fileName }}</a>
              <span class="file-size">({{ (file.fileSize / 1024).toFixed(1) }} KB)</span>
              <button type="button" class="pay-dl" (click)="openPreview(file, $event)" [attr.title]="t('ffDocs.view', 'Посмотреть')" [attr.aria-label]="t('ffDocs.view', 'Посмотреть')"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M1.5 10S4.5 4 10 4s8.5 6 8.5 6-3 6-8.5 6-8.5-6-8.5-6z"/><circle cx="10" cy="10" r="2.5"/></svg></button>
              <button type="button" class="pay-dl file-dl" (click)="onDownloadFile(file, $event)" [attr.title]="t('ffPay.download', 'Скачать')" [attr.aria-label]="t('ffPay.download', 'Скачать')">
                <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 3v10M6 9l4 4 4-4M4 16h12"/></svg>
              </button>
              <button
                *ngIf="isCustomsBroker"
                type="button"
                class="btn-remove-file"
                [disabled]="deletingFileUid === file.uid"
                (click)="deleteDocumentFile(file)"
                [title]="deleteFileText"
              >
                {{ deletingFileUid === file.uid ? '' : '✕' }}
              </button>
            </div>
          </div>
        </div>

        <!-- Форма загрузки -->
        <div *ngIf="documentModalShowingUploadForm" class="document-upload-form">
          <button type="button" class="btn-back" (click)="showDocumentList()">← {{ backText }}</button>
          <div class="form-group">
            <label>{{ filesLabel }}</label>
            <div class="file-upload-area">
              <input 
                type="file" 
                #fileInputDoc 
                multiple 
                (change)="onDocumentFilesSelected($event)" 
                style="display: none;"
              />
              <button type="button" class="btn-choose-files dropzone" (click)="fileInputDoc.click()">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 16V4M7 9l5-5 5 5M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg>
                <span>{{ chooseFilesText }}</span>
              </button>
              <div *ngIf="documentUploadFiles.length > 0" class="selected-files">
                <div *ngFor="let file of documentUploadFiles; let i = index" class="file-item">
                  <span class="file-name">{{ file.name }}</span>
                  <span class="file-size">({{ (file.size / 1024).toFixed(1) }} KB)</span>
                  <button type="button" class="btn-remove-file" (click)="removeDocumentFile(i)">✕</button>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="documentUploadError" class="error-message">
            {{ documentUploadError }}
          </div>
          <div class="form-actions">
            <button type="button" class="btn-cancel" (click)="showDocumentList()">
              {{ cancelText }}
            </button>
            <button 
              type="button" 
              class="btn-submit" 
              (click)="saveDocuments()"
              [disabled]="documentUploadFiles.length === 0 || creatingDocumentActivity"
            >
              {{ creatingDocumentActivity ? savingText : saveText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Модальное окно для добавления активности (запрос) -->
  <div class="modal-overlay" *ngIf="showAddActivityModal" (click)="closeAddActivityModal()">
    <div class="modal-content modal-activity" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{ addActivityText }}</h2>
        <button class="modal-close" (click)="closeAddActivityModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="activityForm" (ngSubmit)="submitActivity()">
          <div class="form-group">
            <label>{{ messageLabel }}</label>
            <textarea formControlName="actorMessage" class="form-control" rows="3" 
                      [placeholder]="activityMessagePlaceholderText"></textarea>
          </div>

          <div class="form-group">
            <label>{{ targetRoleLabel }}</label>
            <select formControlName="targetRoleId" class="form-control">
              <option value="">{{ selectRoleText }}</option>
              <option *ngFor="let role of roles" [value]="role.id">
                {{ role.name }}
              </option>
            </select>
          </div>

          <div *ngIf="activityError" class="error-message">
            {{ activityError }}
          </div>

          <div class="form-actions">
            <button type="button" class="btn-cancel" (click)="closeAddActivityModal()">
              {{ cancelText }}
            </button>
            <button type="submit" class="btn-submit" [disabled]="activityForm.invalid || creatingActivity">
              {{ creatingActivity ? creatingText : submitText }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Модальное окно для просмотра активности -->
  <div class="modal-overlay" *ngIf="showActivityModal" (click)="closeActivityModal()">
    <div class="modal-content modal-activity-detail" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{ selectedActivity ? getActivityText(selectedActivity) : '' }}</h2>
        <button class="modal-close" (click)="closeActivityModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="modal-body" *ngIf="selectedActivity">
        <!-- Информация об активности -->
        <div class="activity-detail-info">
          <div class="info-row">
            <span class="info-label">{{ activityTypeText }}:</span>
            <span class="info-value">{{ getActivityTypeName(selectedActivity) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ createdAtText }}:</span>
            <span class="info-value">{{ formatDate(selectedActivity.createdAt) }}</span>
          </div>
          <div *ngIf="selectedActivity.actorRole" class="info-row">
            <span class="info-label">{{ initiatorText }}:</span>
            <span class="info-value">{{ selectedActivity.actorRole.name }}</span>
          </div>
          <div *ngIf="selectedActivity.targetRole" class="info-row">
            <span class="info-label">{{ requestRecipientText }}:</span>
            <span class="info-value">{{ selectedActivity.targetRole.name }}</span>
          </div>
          <div *ngIf="selectedActivity.request" class="info-row">
            <span class="info-label">{{ requestStatusText }}:</span>
            <span class="info-value">
              <span *ngIf="!selectedActivity.completed" class="status-badge status-pending">{{ requestPendingText }}</span>
              <span *ngIf="selectedActivity.completed" class="status-badge status-completed">{{ requestCompletedText }}</span>
            </span>
          </div>
          <div *ngIf="selectedActivity.actorMessage" class="info-row">
            <span class="info-label">{{ actorMessageText }}:</span>
            <span class="info-value">{{ selectedActivity.actorMessage }}</span>
          </div>
          <div *ngIf="selectedActivity.targetMessage" class="info-row">
            <span class="info-label">{{ targetMessageText }}:</span>
            <span class="info-value">{{ selectedActivity.targetMessage }}</span>
          </div>
        </div>
        
        <!-- Секция завершения активности (для запросов) -->
        <div *ngIf="canCompleteActivity(selectedActivity)" class="activity-complete-section">
          <h4>{{ completeActivityText }}</h4>
          <form [formGroup]="completeActivityInlineForm" (ngSubmit)="submitCompleteActivityInline()">
            <div class="form-group">
              <label>{{ completeActivityMessageLabel }}</label>
              <textarea formControlName="targetMessage" class="form-control" rows="3" 
                        [placeholder]="targetMessagePlaceholderText"></textarea>
            </div>

            <div *ngIf="completeActivityError" class="error-message">
              {{ completeActivityError }}
            </div>
            
            <div *ngIf="selectedActivity.completed" class="success-message">
              ✓ {{ activityCompletedSuccessText }}
            </div>

            <div class="form-actions">
              <button *ngIf="!selectedActivity.completed" type="submit" class="btn-submit" [disabled]="completeActivityInlineForm.invalid || completingActivity">
                {{ completingActivity ? completingText : completeActivityText }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Модальное окно для завершения активности (старое, можно удалить если не используется) -->
  <div class="modal-overlay" *ngIf="showCompleteActivityModal" (click)="closeCompleteActivityModal()">
    <div class="modal-content modal-activity" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{ completeActivityText }}</h2>
        <button class="modal-close" (click)="closeCompleteActivityModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="selectedActivity" class="activity-info">
          <div class="info-row">
            <span class="info-label">{{ activityTypeText }}:</span>
            <span class="info-value">{{ getActivityTypeName(selectedActivity) }}</span>
          </div>
          <div *ngIf="selectedActivity.actorMessage" class="info-row">
            <span class="info-label">{{ requestColonLabelText }}</span>
            <span class="info-value">{{ selectedActivity.actorMessage }}</span>
          </div>
        </div>
        
        <form [formGroup]="completeActivityForm" (ngSubmit)="submitCompleteActivity()">
          <div class="form-group">
            <label>{{ completeActivityMessageLabel }}</label>
            <textarea formControlName="targetMessage" class="form-control" rows="3" 
                      [placeholder]="targetMessagePlaceholderText"></textarea>
          </div>

          <!-- Загрузка файлов при завершении активности -->
          <div class="form-group">
            <label>{{ filesLabel }}</label>
            <div class="file-upload-section">
              <input 
                type="file" 
                #fileInputComplete 
                [id]="'fileInputComplete_' + selectedActivity?.id"
                multiple 
                (change)="onFilesSelectedForCompleteActivity($event)" 
                style="display: none;"
              />
              <button type="button" class="btn-choose-files" (click)="fileInputComplete.click()">
                {{ chooseFilesText }}
              </button>
              
              <div *ngIf="getSelectedFilesForComplete().length > 0" class="selected-files">
                <div *ngFor="let file of getSelectedFilesForComplete(); let i = index" class="file-item">
                  <span class="file-name">{{ file.name }}</span>
                  <span class="file-size">({{ (file.size / 1024).toFixed(1) }} KB)</span>
                  <button type="button" class="btn-remove-file" (click)="removeFileFromCompleteList(i)">✕</button>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="completeActivityError" class="error-message">
            {{ completeActivityError }}
          </div>

          <div class="form-actions">
            <button type="button" class="btn-cancel" (click)="closeCompleteActivityModal()">
              {{ cancelText }}
            </button>
            <button type="submit" class="btn-submit" [disabled]="completingActivity">
              {{ completingActivity ? completingText : submitText }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Модальное окно для просмотра ставки -->
  <div class="modal-overlay" *ngIf="showBidModal" (click)="closeBidModal()">
    <div class="modal-content modal-activity" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{ bidInfoText }} {{ deal?.bid?.id | docNo:'B':deal?.bid?.createdAt }}</h2>
        <button class="modal-close" (click)="closeBidModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="modal-body" *ngIf="deal?.bid as bid">
        <div class="bid-detail-info">
          <div class="info-row">
            <span class="info-label">{{ companyText }}:</span>
            <span class="info-value">{{ deal?.freightForwarder?.companyName }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ priceText }}:</span>
            <span class="info-value info-value--big">{{ fmtMoney(bid.price, bid.currencyCode) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ deliveryDaysText }}:</span>
            <span class="info-value">{{ bid.deliveryDays }} {{ daysText }}</span>
          </div>
          <div class="info-row" *ngIf="bid.services && bid.services.length > 0">
            <span class="info-label">{{ servicesText }}:</span>
            <span class="info-value service-chips">
              <span *ngFor="let s of bid.services" class="service-chip">{{ getServiceName(s) }}</span>
            </span>
          </div>
          <div class="info-row" *ngIf="bid.note">
            <span class="info-label">{{ noteText }}:</span>
            <span class="info-value">{{ bid.note }}</span>
          </div>
          <div class="info-row" *ngIf="bid.createdAt">
            <span class="info-label">{{ createdAtText }}:</span>
            <span class="info-value">{{ formatDate(bid.createdAt) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Модальное окно для просмотра реквизитов -->
  <div class="modal-overlay" *ngIf="showRequisitesModal" (click)="closeRequisitesModal()">
    <div class="modal-content modal-requisites" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{ requisitesText }}</h2>
        <button *ngIf="cargoOwnerRequisites" type="button" class="copy-req" [class.is-done]="requisitesCopied" (click)="copyRequisites()">
          <svg *ngIf="!requisitesCopied" viewBox="0 0 20 20" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="2"/><path d="M13 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/></svg>
          <svg *ngIf="requisitesCopied" viewBox="0 0 20 20" aria-hidden="true"><path d="M4.5 10.5l3.5 3.5 7.5-8"/></svg>
          {{ requisitesCopied ? t('ffRequest.copied', 'Скопировано') : t('ffRequest.copy', 'Скопировать') }}
        </button>
        <button class="modal-close" (click)="closeRequisitesModal()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <app-view-requisites 
          [requisites]="cargoOwnerRequisites"
          [companyName]="requisitesCompanyName"
          [loading]="loadingRequisites"
          [error]="requisitesError">
        </app-view-requisites>
      </div>
    </div>
  </div>
</div>
